
import { useMemo } from 'react';

export const useFAQWithDynamicDays = (numberOfDaysBeforePlanStart?: number) => {
  const FAQArray = useMemo(() => [
    {
      question: 'How do I set up the employer bank account?',
      answer: 'During the setup process, follow the screen prompts to designate the bank that will be used for all account funding and contribution transactions. We will pull money directly from this account, so be sure to enter the bank account and routing numbers accurately.'
    },
    {
      question: 'Why do I need to enter plan copays?',
      answer: 'Plan copay matching is used to auto-adjudicate claims and reduces the amount of documentation that your employees will be required to submit. It is a best practice to enter all copays for your health plans.'
    },
    {
      question: 'Can I add additional admins to assist with the setup process?',
      answer: 'Yes. You may add additional administrators and set their level of access by selecting Contacts on the home page.'
    },
    {
      question: 'When will my plans go live?',
      answer: 'You decide! Your plans will go live at the date you indicate during the setup process.'
    },
    {
      question: 'When will my employees receive their payment cards?',
      answer: `Cards are mailed within ${numberOfDaysBeforePlanStart} days prior to the plan start date.`
    },
    {
      question: 'How far ahead of my plan start date must I complete my setup?',
      answer: 'Your setup can be completed at any time and we can begin administering the plan as early as the next day. However, we recommend that you complete your setup at least 20 days before your plan start date so your employees\' accounts can be opened and payment cards can be mailed.'
    }
  ], [numberOfDaysBeforePlanStart]);

  return FAQArray;
};
